<script>
import { props } from './helper'
import { defineComponent } from 'vue'
export default defineComponent({
  props,
  setup () {
    // 不渲染
    return () => null
  }
})
</script>
<style lang="less">
.schema-form__item {
  &.abstract {
    margin: 0;
  }
}
</style>
